import { cva } from 'class-variance-authority';

export const sectionShellMobileNavigationVariants = cva('min-h-0 min-w-0 flex-1', {
  variants: {
    active: {
      true: 'flex flex-col',
      false: 'hidden',
    },
  },
  defaultVariants: { active: false },
});
